import { render, staticRenderFns } from "./AdditionalInfoAgreements.vue?vue&type=template&id=d303d620&scoped=true&"
import script from "./AdditionalInfoAgreements.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoAgreements.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfoAgreements.vue?vue&type=style&index=0&id=d303d620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d303d620",
  null
  
)

export default component.exports